/**
 * MONTKUSH TV BOGO Page — tv-bogo.js
 * Vanilla JS only. No jQuery, no frameworks.
 *
 * Flow:
 *  1. Customer selects a flavor tab (Natural / Mint)
 *  2. Customer selects a strength package card
 *  3. Click "Claim the BOGO Offer" (inline or sticky bar)
 *  4. Suppress Rebuy Smart Cart + Dawn cart drawer
 *  5. POST to /cart/clear.js then /cart/add.js
 *  6. Redirect to /checkout?discount=BOGOCODE,FREEGUMMY,FREESHIP
 *
 * Sticky bar:
 *  Appears after the native CTA scrolls out of view (IntersectionObserver).
 *  Updates label to show selected package. Hides when native CTA is visible.
 */

(function () {
  'use strict';

  // ── Package data ────────────────────────────────────────────
  // ── Package images ──────────────────────────────────────────
  // Replace these URLs with your actual product images once ready.
  // Use Shopify CDN URLs from the Files section of your admin.
  // Format: 'https://cdn.shopify.com/s/files/1/xxxx/xxxx/files/your-image.jpg'
  const PKG_IMAGES = {
    'nat-500':   'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/500-mg-nat-bogo.jpg?v=1781885167',
    'nat-1000':  'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1000-mg-nat-bogo.jpg?v=1781885167',
    'nat-1500':  'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1500-mg-nat-bogo.jpg?v=1781885167',
    'mint-500':  'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/500-mg-mint-bogo.jpg?v=1781885167',
    'mint-1000': 'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1000-mg-mint-bogo.jpg?v=1781885167',
    'mint-1500': 'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1500-mg-mint-bogo.jpg?v=1781885167',
  };

  // Single-bottle images for the "Your Bundle Includes" card (cleaner, no gummies/multi-product)
  const INCLUDES_IMAGES = {
    'nat-500':   'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/500mg_Natural.jpg?v=1781887812',
    'nat-1000':  'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1000mg_Natural__56342.1706215922.1280.1280__15023.1713528987.1280.1280.jpg?v=1736462966',
    'nat-1500':  'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/1500mg_Natural.jpg?v=1781887865',
    'mint-1000': 'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/Mint-1000mg-cbd-oil-leaf__55155.1670444906.1280.1280.jpg?v=1736462760',
    'mint-1500': 'https://cdn.shopify.com/s/files/1/0655/6018/2936/files/Mint-1500mg-cbd-oil-leaf.jpg?v=1781887748',
  };

  const PACKAGES = [
    {
      id: 'nat-500',
      flavor: 'natural',
      label: '500mg Natural',
      detail: 'Mild strength · Natural flavor',
      price: '$59.99',
      comparePrice: '$134.97',
      variantId: '45107953336472',
      discountCode: 'NAT500TVBOGO',
      soldOut: true,
    },
    {
      id: 'nat-1000',
      flavor: 'natural',
      label: '1000mg Natural',
      detail: 'Medium strength · Natural flavor',
      price: '$99.99',
      comparePrice: '$214.97',
      variantId: '45107953402008',
      discountCode: 'NAT1000TVBOGO',
      soldOut: false,
    },
    {
      id: 'nat-1500',
      flavor: 'natural',
      label: '1500mg Natural',
      detail: 'Maximum strength · Natural flavor',
      price: '$124.99',
      comparePrice: '$264.97',
      variantId: '45107953434776',
      discountCode: 'NAT1500TVBOGO',
      soldOut: false,
    },
    {
      id: 'mint-500',
      flavor: 'mint',
      label: '500mg Mint',
      detail: 'Mild strength · Mint flavor',
      price: '$59.99',
      comparePrice: '$134.97',
      variantId: null,
      discountCode: null,
      soldOut: true,
    },
    {
      id: 'mint-1000',
      flavor: 'mint',
      label: '1000mg Mint',
      detail: 'Medium strength · Mint flavor',
      price: '$99.99',
      comparePrice: '$214.97',
      variantId: '45107953107096',
      discountCode: 'MINT1000TVBOGO',
      soldOut: false,
    },
    {
      id: 'mint-1500',
      flavor: 'mint',
      label: '1500mg Mint',
      detail: 'Maximum strength · Mint flavor',
      price: '$124.99',
      comparePrice: '$264.97',
      variantId: '45107953139864',
      discountCode: 'MINT1500TVBOGO',
      soldOut: false,
    },
  ];

  const FREE_GUMMY_VARIANT_ID = '45107953827992';
  const FREE_GUMMY_CODE = 'FREEGUMMY';
  const FREE_SHIP_CODE = 'FREESHIP';

  // ── State ────────────────────────────────────────────────────
  let selectedFlavor = 'natural';
  let selectedPackageId = 'nat-1000'; // default: 1000mg Natural

  // ── DOM refs ─────────────────────────────────────────────────
  const bogoRoot = document.querySelector('.mk-bogo');
  if (!bogoRoot) return;

  const flavorTabs = bogoRoot.querySelectorAll('.mk-bogo__flavor-tab');
  const packagesContainer = bogoRoot.querySelector('.mk-bogo__packages');
  const stickyBar = document.getElementById('mk-bogo-sticky');
  const stickyDetail = document.getElementById('mk-bogo-sticky-detail');
  const stickySelector = document.getElementById('mk-bogo-sticky-selector');
  const stickyFlyup = document.getElementById('mk-bogo-sticky-flyup');
  const stickyFlyupInner = document.getElementById('mk-bogo-sticky-flyup-inner');
  const stickyThumbWrap = document.getElementById('mk-bogo-sticky-thumb-wrap');
  const nativeCta = document.getElementById('mk-bogo-native-cta');

  // All CTA buttons (inline + sticky) — collected after render
  function getCtaBtns() {
    return document.querySelectorAll('.mk-bogo__cta-btn');
  }

  // ── Render packages ──────────────────────────────────────────
  function renderPackages() {
    if (!packagesContainer) return;
    packagesContainer.innerHTML = '';

    const filtered = PACKAGES.filter((p) => p.flavor === selectedFlavor);

    filtered.forEach((pkg) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'mk-bogo__package';
      card.setAttribute('data-package-id', pkg.id);
      card.setAttribute('aria-pressed', String(pkg.id === selectedPackageId));

      if (pkg.soldOut) {
        card.classList.add('is-soldout');
        card.disabled = true;
        card.setAttribute('aria-disabled', 'true');
      } else if (pkg.id === selectedPackageId) {
        card.classList.add('is-selected');
      }

      const imgUrl = PKG_IMAGES[pkg.id] || '';
      const thumbHtml = imgUrl
        ? `<img src="${imgUrl}" alt="${pkg.label}" class="mk-bogo__package-thumb" width="56" height="56" loading="lazy">`
        : `<span class="mk-bogo__package-thumb mk-bogo__package-thumb--placeholder" aria-hidden="true">
             <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
               <rect x="8" y="2" width="8" height="20" rx="3" stroke="currentColor" stroke-width="1.5"/>
               <circle cx="12" cy="6" r="1" fill="currentColor"/>
             </svg>
           </span>`;

      const checkSvg = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      card.innerHTML = `
        <span class="mk-bogo__pkg-top">
          <span class="mk-bogo__package-radio" aria-hidden="true"></span>
          ${thumbHtml}
          <span class="mk-bogo__pkg-name-wrap">
            <span class="mk-bogo__package-label">${pkg.label}</span>
            <span class="mk-bogo__package-detail">${pkg.detail}</span>
          </span>
          <span class="mk-bogo__package-price-wrap">
            <span class="mk-bogo__package-compare">${pkg.comparePrice}</span>
            <span class="mk-bogo__package-price">${pkg.price}</span>
          </span>
        </span>
        <span class="mk-bogo__pkg-pills">
          <span class="mk-bogo__pkg-pill">${checkSvg}1 &times; ${pkg.label}</span>
          <span class="mk-bogo__pkg-pill mk-bogo__pkg-pill--free">${checkSvg}1 &times; ${pkg.label} FREE</span>
          <span class="mk-bogo__pkg-pill mk-bogo__pkg-pill--free">${checkSvg}Free 10-ct gummy</span>
          <span class="mk-bogo__pkg-pill mk-bogo__pkg-pill--free">${checkSvg}Free shipping</span>
        </span>
        ${pkg.soldOut ? '<span class="mk-bogo__package-soldout-badge">Sold Out</span>' : ''}
      `;

      if (!pkg.soldOut) {
        card.addEventListener('click', () => selectPackage(pkg.id));
      }

      packagesContainer.appendChild(card);
    });
  }

  // ── Select package ───────────────────────────────────────────
  function selectPackage(pkgId) {
    const previousId = selectedPackageId;
    selectedPackageId = pkgId;

    const cards = packagesContainer.querySelectorAll('.mk-bogo__package');
    cards.forEach((card) => {
      const isSelected = card.getAttribute('data-package-id') === pkgId;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', String(isSelected));
    });

    // Silently clear the cart whenever the customer switches packages
    // so stale items from a previous selection never carry over to checkout.
    // suppressCartUI() is called before AND after the fetch so the Dawn
    // cart drawer / Rebuy Smart Cart never opens during a bundle swap.
    if (previousId !== pkgId) {
      suppressCartUI();
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => suppressCartUI())
        .catch(() => {});
    }

    updateCtaState();
    updateStickyDetail();
  }

  // ── Select flavor ────────────────────────────────────────────
  function selectFlavor(flavor) {
    selectedFlavor = flavor;

    flavorTabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-flavor') === flavor;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', String(isActive));
    });

    // Auto-select first available package in new flavor
    const firstAvailable = PACKAGES.find((p) => p.flavor === flavor && !p.soldOut);
    if (firstAvailable) {
      selectedPackageId = firstAvailable.id;
    }

    // Clear cart silently when flavor changes so stale items never persist
    suppressCartUI();
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => suppressCartUI())
      .catch(() => {});

    renderPackages();
    updateCtaState();
    updateStickyDetail();
  }

  // ── Update CTA button state ──────────────────────────────────
  function updateCtaState() {
    const pkg = PACKAGES.find((p) => p.id === selectedPackageId);
    const isValid = pkg && !pkg.soldOut;

    getCtaBtns().forEach((btn) => {
      // Don't disable the hero scroll-anchor link
      if (btn.tagName === 'A') return;
      btn.disabled = !isValid;
    });
  }

  // ── Update sticky bar selector label, thumbnail + rebuild flyup options ──
  function updateStickyDetail() {
    const pkg = PACKAGES.find((p) => p.id === selectedPackageId);

    // Update selector label
    if (stickyDetail) {
      if (pkg && !pkg.soldOut) {
        stickyDetail.textContent = `${pkg.label} — ${pkg.price}`;
      } else {
        stickyDetail.textContent = 'Choose your strength';
      }
    }

    // Update sticky thumbnail
    if (stickyThumbWrap && pkg) {
      const imgUrl = PKG_IMAGES[pkg.id] || '';
      let thumbEl = stickyThumbWrap.querySelector('.mk-bogo__sticky-thumb, .mk-bogo__sticky-thumb--placeholder');
      if (imgUrl) {
        if (thumbEl && thumbEl.tagName === 'IMG') {
          thumbEl.src = imgUrl;
          thumbEl.alt = pkg.label;
        } else {
          // Replace placeholder with real img
          const img = document.createElement('img');
          img.src = imgUrl;
          img.alt = pkg.label;
          img.className = 'mk-bogo__sticky-thumb';
          img.width = 40;
          img.height = 40;
          img.loading = 'eager';
          if (thumbEl) thumbEl.replaceWith(img);
          else stickyThumbWrap.prepend(img);
        }
      }
    }

    // Update includes section oil image
    const includesOilImg = document.getElementById('mk-bogo-includes-oil-img');
    const includesOilDetail = document.getElementById('mk-bogo-includes-oil-detail');
    if (includesOilImg && pkg && INCLUDES_IMAGES[pkg.id]) {
      includesOilImg.src = INCLUDES_IMAGES[pkg.id];
      includesOilImg.alt = pkg.label;
    }
    if (includesOilDetail && pkg) {
      includesOilDetail.textContent = pkg.label;
    }

    // Rebuild flyup option list
    if (!stickyFlyupInner) return;
    stickyFlyupInner.innerHTML = '';

    // Show all packages in current flavor
    const filtered = PACKAGES.filter((p) => p.flavor === selectedFlavor);
    filtered.forEach((p) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mk-bogo__sticky-option' + (p.id === selectedPackageId ? ' is-selected' : '');
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', String(p.id === selectedPackageId));
      if (p.soldOut) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }

      btn.innerHTML = `
        <span class="mk-bogo__sticky-option-left">
          <span class="mk-bogo__sticky-option-radio" aria-hidden="true"></span>
          <span>
            <span class="mk-bogo__sticky-option-name">${p.label}</span>
            <span class="mk-bogo__sticky-option-detail">${p.detail}</span>
          </span>
        </span>
        ${p.soldOut
          ? '<span class="mk-bogo__sticky-option-soldout">Sold Out</span>'
          : `<span class="mk-bogo__sticky-option-price">${p.price}</span>`
        }
      `;

      if (!p.soldOut) {
        btn.addEventListener('click', () => {
          selectPackage(p.id);
          closeStickyFlyup();
        });
      }

      stickyFlyupInner.appendChild(btn);
    });
  }

  // ── Open / close sticky flyup ────────────────────────────────
  function openStickyFlyup() {
    if (!stickyFlyup || !stickySelector) return;
    stickyFlyup.classList.add('is-open');
    stickyFlyup.setAttribute('aria-hidden', 'false');
    stickySelector.setAttribute('aria-expanded', 'true');
  }

  function closeStickyFlyup() {
    if (!stickyFlyup || !stickySelector) return;
    stickyFlyup.classList.remove('is-open');
    stickyFlyup.setAttribute('aria-hidden', 'true');
    stickySelector.setAttribute('aria-expanded', 'false');
  }

  function toggleStickyFlyup() {
    if (stickyFlyup && stickyFlyup.classList.contains('is-open')) {
      closeStickyFlyup();
    } else {
      openStickyFlyup();
    }
  }

  // ── Sticky bar visibility (IntersectionObserver) ─────────────
  function initStickyBar() {
    if (!stickyBar || !nativeCta) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', !isVisible);
          stickyBar.setAttribute('aria-hidden', String(isVisible));
          // Close flyup when bar hides
          if (isVisible) closeStickyFlyup();
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(nativeCta);

    // Selector toggle
    if (stickySelector) {
      stickySelector.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleStickyFlyup();
      });
    }

    // Close flyup when clicking outside
    document.addEventListener('click', (e) => {
      if (
        stickyFlyup &&
        stickyFlyup.classList.contains('is-open') &&
        !stickyBar.contains(e.target)
      ) {
        closeStickyFlyup();
      }
    });

    // Close flyup on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeStickyFlyup();
    });
  }

  // ── Suppress Rebuy Smart Cart + Dawn cart drawer ─────────────
  // Rebuy Smart Cart opens by listening to Shopify's global
  // cart update events and by watching /cart/add.js responses.
  // We block it by:
  //  1. Setting window.__mkBogoRedirecting = true BEFORE the fetch
  //  2. Monkey-patching Rebuy's SDK open methods to no-ops
  //  3. Immediately hiding drawer/notification DOM elements
  //  4. Redirecting to checkout before Rebuy's async handlers fire
  function suppressCartUI() {
    window.__mkBogoRedirecting = true;

    // Rebuy Smart Cart SDK (current versions)
    if (window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.show = function () {};
      window.Rebuy.SmartCart.open = function () {};
      window.Rebuy.SmartCart.toggle = function () {};
    }
    // Older Rebuy SDK
    if (window.rebuy && window.rebuy.cart) {
      window.rebuy.cart.open = function () {};
      window.rebuy.cart.show = function () {};
    }

    // Dawn cart drawer / notification
    document.querySelectorAll('cart-drawer, cart-notification').forEach((el) => {
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });

    // Rebuy Smart Cart DOM element
    document.querySelectorAll('#rebuy-cart, .rebuy-cart, [data-rebuy-cart]').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    });

    // Remove body scroll-lock classes Rebuy applies
    document.body.classList.remove('rebuy-cart--open', 'cart-active', 'overflow-hidden');
  }

  // ── Upsell products — variant IDs hardcoded directly ──────────
  const UPSELL_PRODUCTS = [
    { checkboxId: 'mk-bogo-upsell-gummy',  variantId: '48003842375832', discountCode: 'sullyskit' },
    { checkboxId: 'mk-bogo-upsell-rollon', variantId: '45107952844952', discountCode: 'sullyskit' },
  ];

  // No async lookup needed — variant IDs are hardcoded above
  function resolveUpsellVariants() {
    UPSELL_PRODUCTS.forEach((upsell) => {
      const el = document.getElementById(upsell.checkboxId);
      if (el) el.dataset.variantId = upsell.variantId;
    });
  }

  // ── Add to cart + redirect ───────────────────────────────────
  async function handleClaim() {
    const pkg = PACKAGES.find((p) => p.id === selectedPackageId);
    if (!pkg || pkg.soldOut) return;

    setLoading(true);

    // Suppress cart UI before the fetch fires
    suppressCartUI();
    const suppressInterval = setInterval(suppressCartUI, 50);

    try {
      // Clear stale cart items
      await fetch('/cart/clear.js', { method: 'POST' });

      // 2× selected CBD oil + 1× free gummy
      // Omit sections[] — prevents Dawn's cart-drawer renderContents
      const items = [
        { id: parseInt(pkg.variantId, 10), quantity: 2 },
        { id: parseInt(FREE_GUMMY_VARIANT_ID, 10), quantity: 1 },
      ];

      // Add any checked upsell items
      const upsellCodes = [];
      UPSELL_PRODUCTS.forEach((upsell) => {
        const checkbox = document.getElementById(upsell.checkboxId);
        if (checkbox && checkbox.checked) {
          const variantId = checkbox.dataset.variantId;
          if (variantId && variantId !== '') {
            items.push({ id: parseInt(variantId, 10), quantity: 1 });
            if (upsell.discountCode && !upsellCodes.includes(upsell.discountCode)) {
              upsellCodes.push(upsell.discountCode);
            }
          }
        }
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const err = await response.json();
        clearInterval(suppressInterval);
        throw new Error(err.description || 'Could not add items to cart.');
      }

      suppressCartUI();
      clearInterval(suppressInterval);

      // Build discount string: BOGO code + free gummy + free ship + any upsell codes
      const allCodes = [pkg.discountCode, FREE_GUMMY_CODE, FREE_SHIP_CODE, ...upsellCodes]
        .filter(Boolean)
        .join(',');

      const checkoutUrl = `/checkout?discount=${encodeURIComponent(allCodes)}`;
      window.location.href = checkoutUrl;

    } catch (error) {
      clearInterval(suppressInterval);
      window.__mkBogoRedirecting = false;
      console.error('[MONTKUSH BOGO]', error);
      setLoading(false);
      showError(error.message || 'Something went wrong. Please try again.');
    }
  }

  // ── Loading helpers ──────────────────────────────────────────
  function setLoading(state) {
    getCtaBtns().forEach((btn) => {
      if (btn.tagName === 'A') return;
      btn.classList.toggle('is-loading', state);
      btn.disabled = state;
      if (state) {
        btn.setAttribute('data-original-text', btn.textContent.trim());
        btn.textContent = 'Adding to cart…';
      } else {
        const orig = btn.getAttribute('data-original-text');
        if (orig) btn.textContent = orig;
      }
    });
  }

  function showError(msg) {
    let errorEl = document.querySelector('.mk-bogo__error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'mk-bogo__error';
      errorEl.style.cssText = 'color:#c0392b;font-size:14px;text-align:center;margin-top:12px;font-weight:600;';
      const ctaWrap = document.querySelector('#mk-bogo-native-cta .mk-bogo__cta-wrap');
      if (ctaWrap) ctaWrap.appendChild(errorEl);
    }
    errorEl.textContent = msg;
    setTimeout(() => { errorEl.textContent = ''; }, 6000);
  }

  // ── Init ─────────────────────────────────────────────────────
  function init() {
    // ── Permanently block the cart drawer on this page ─────────────
    // Dawn fires a 'cart:change' CustomEvent on the document whenever
    // /cart/clear.js or /cart/add.js resolves. Intercept it at capture
    // phase so it never reaches the cart-drawer web component.
    document.addEventListener('cart:change', function (e) {
      e.stopImmediatePropagation();
      suppressCartUI();
    }, true);

    // Intercept the older cart-notification open event
    document.addEventListener('cart-notification:open', function (e) {
      e.stopImmediatePropagation();
    }, true);

    // Block open events on the cart-drawer element itself
    document.querySelectorAll('cart-drawer').forEach(function (el) {
      el.addEventListener('open', function (e) { e.stopImmediatePropagation(); }, true);
    });

    // Flavor tab listeners
    flavorTabs.forEach((tab) => {
      tab.addEventListener('click', () => selectFlavor(tab.getAttribute('data-flavor')));
    });

    // Initial render
    renderPackages();
    updateCtaState();
    updateStickyDetail();

    // Resolve upsell product variant IDs asynchronously
    resolveUpsellVariants();

    // CTA button listeners — covers both inline CTA and sticky bar button
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.mk-bogo__cta-btn, .mk-bogo__sticky-btn');
      if (!btn || btn.tagName === 'A' || btn.disabled) return;
      handleClaim();
    });

    // Sticky bar
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
